// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { OnlineContentFormatType } from "../schema";

export function serialize_OnlineContentFormatType_internal(value: OnlineContentFormatType): unknown {
  return ((value: "ARTICLE" | "BLOGPOST" | "PODCAST" | "REPORT" | "VIDEO"): unknown => {
    return value;
  })(value);
}
export function serialize_OnlineContentFormatType(obj: OnlineContentFormatType): string {
  return renderJsonWithNumbersAsBigint(serialize_OnlineContentFormatType_internal(obj));
}
export function deserialize_OnlineContentFormatType_internal(value: unknown): ParserResult<OnlineContentFormatType> {
  return ((value: unknown): ParserResult<"ARTICLE" | "BLOGPOST" | "PODCAST" | "REPORT" | "VIDEO"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/OnlineContentFormatType]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "ARTICLE":
        return { success: true, value: "ARTICLE" };
      case "BLOGPOST":
        return { success: true, value: "BLOGPOST" };
      case "PODCAST":
        return { success: true, value: "PODCAST" };
      case "REPORT":
        return { success: true, value: "REPORT" };
      case "VIDEO":
        return { success: true, value: "VIDEO" };
      default:
        return { success: false, reason: `[#/components/schemas/OnlineContentFormatType]: '${value}' expected to be enum, one of 'ARTICLE, BLOGPOST, PODCAST, REPORT, VIDEO'.` };
    }
  })(value);
}
export function deserialize_OnlineContentFormatType(str: string): ParserResult<OnlineContentFormatType> {
  return deserialize_OnlineContentFormatType_internal(parseJsonWithNumbersAsBigint(str));
}
